// extracted by mini-css-extract-plugin
module.exports =  {"root":"Select-module__root--WvoF2"};